import React, { useState } from 'react';
import { get, post, put } from '../services/apiController';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { EditIcon } from './icons';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../components/Breadcrumb';
import useDebounce from './useDebounce';
import { DEBOUNCE_DELAY } from '../util/constant';

const ItemCategory = () => {
  const formFields = { name: '', description: '' };
  const [categoryForm, setCategoryForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [query, setQuery] = useState('');

  const handleShow = () => {
    setShowConfirmModel(true);
    setCategoryForm(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    setCategoryForm(categoryList.find((item) => item.id === +id));
    setShowConfirmModel(true);
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setCategoryForm({ ...categoryForm, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in categoryForm) {
      try {
        await put(categoryForm, '/inv/item-categories/' + categoryForm.id);
        toast.success('Item Category updated successfully');
        setShowConfirmModel(false);
        getCategories();
      } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong', { autoClose: 3000 });
      }
    } else {
      try {
        await post(categoryForm, '/inv/item-categories');
        toast.success('Item Category added successfully');
        setShowConfirmModel(false);
        getCategories();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
      }
    }
  };

  function getCategories() {
    try {
      get(`/inv/item-categories/?search=${query}`).then((response) => {
        setCategoryList(response.data || []);
      });
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Something went wrong');
    }
  }

  useDebounce(
    () => getCategories(),
    [query],
    DEBOUNCE_DELAY
  );

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Inventory' },
          { link: '#', title: 'Item Categories' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Item Categories | {categoryList.length ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              placeholder="Search by category name"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <button type="button" className="btn app-btn-default dark-color " onClick={handleShow}>
              Add Category
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Category Name</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Updated By</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categoryList.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{index + 1}</td>
                        <td>{item?.name}</td>
                        <td>{item?.description}</td>
                        <td>{item?.isActive ? 'Active' : 'Inactive'}</td>
                        <td>{item?.createdByUser?.name || 'N/A'}</td>
                        <td>{item?.updatedByUser?.name || 'N/A'}</td>
                        <td className="actions">
                          <span onClick={(e) => handleEdit(e, item?.id)} className="edit-icon">
                            <EditIcon style={{ color: 'teal' }} />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{'id' in categoryForm ? 'Edit Category' : 'Add Category'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <Row>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Category Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="name"
                    value={categoryForm.name}
                    onChange={handleChange}
                    type="text"
                    placeholder="Category Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    className="input"
                    name="description"
                    value={categoryForm.description}
                    onChange={handleChange}
                    type="text"
                    placeholder="Description"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <div className="container text-center">
              <Button type="submit" onClick={handleSubmit} className="add-request-btn mt-4 mb-3">
                {'id' in categoryForm ? 'Update' : 'Add'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ItemCategory;
